import axios from 'axios'
import {BUSCAR_AGENDAMENTOS_VIAGENS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';
import {montarURLFiltro} from '../../util/filtros';

export default function buscarAgendamentosViagens(empresaId, filtros) {
    const urlFiltros = montarURLFiltro(filtros, 1, 10);
    const url = `${URL}/agendamento-viagem/empresa/${empresaId}${urlFiltros}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_AGENDAMENTOS_VIAGENS,
            payload: response,

        }),
    );
}
